import { ApiSignalFetchers } from "@/apis/api_signals"
import { ModalSlideUpStaticMethods } from "@/components/composite/ModalSlideUp/main"
import KycPageSignals from "@/features_signal/kyc/kycPageSignals"

export const RoutesPages = {
    HomePage: () =>
        import("./HomePage/page").then((module) => ({
            Component: module.default,
        })),
    LoginPageV2: () =>
        import("./LoginPageV2/page").then((module) => ({
            Component: module.default,
        })),
    UserCenterPage: () =>
        import("./UserCenterPage/page").then((module) => ({
            Component: module.default,
        })),
    BetRecordPage: () =>
        import("./BetRecordPage/page").then((module) => ({
            Component: module.default,
        })),
    AccountPage: () =>
        import("./AccountPage/page").then((module) => ({
            Component: module.default,
        })),
    TransactionStatusPage: () =>
        import("./TransactionStatusPage/page").then((module) => ({
            Component: module.default,
        })),
    TransactionRecordPage: () =>
        import("./TransactionRecordPage/page").then((module) => ({
            Component: module.default,
        })),
    Walfare: () =>
        import("./Walfare/page").then((module) => ({
            Component: module.default,
        })),
    BlindBox: () =>
        import("./BlindBox/page").then((module) => ({
            Component: module.default,
        })),
    DailyWins: () =>
        import("./DailyWins/page").then((module) => ({
            Component: module.default,
        })),
    MandatoryPage: () =>
        import("./MandatoryPage/page").then((module) => ({
            Component: module.default,
        })),
    InvitePage: () =>
        import("./InvitePage/page").then((module) => ({
            Component: module.default,
        })),
    PointsPage: () =>
        import("./PointsPage/page").then((module) => ({
            Component: module.default,
        })),
    GamePage: () =>
        import("./GamePage/page").then((module) => ({
            Component: module.default,
        })),
    WithdrawAccounts: () =>
        import("./WithdrawAccounts/page").then((module) => ({
            Component: module.default,
        })),
    NotFoundPage: () =>
        import("./NotFoundPage").then((module) => ({
            Component: module.default,
        })),

    KycPage: () =>
        import("./KycPage/page").then((module) => ({
            Component: module.default,
        })),
    RedirectPage: () =>
        import("./RedirectPage/page").then((module) => ({
            Component: module.default,
        })),
    DocsPage: () =>
        import("./DocsPage/page").then((module) => ({
            Component: module.default,
        })),
    DownloadPage: () =>
        import("./DownloadPage/page").then((module) => ({
            Component: module.default,
        })),
    VipPage: () =>
        import("./Vip/page").then((module) => ({
            Component: module.default,
        })),
    LevelSystem: () =>
        import("./Vip/LevelSystem").then((module) => ({
            Component: module.default,
        })),
}

export const RoutesPagesLoader = {
    KycPage: async () => {
        KycPageSignals.resetStage()
        KycPageSignals.resetFormData()
        await Promise.all([
            //
            ModalSlideUpStaticMethods.closeAll(),
            KycPageSignals.fetchKyc(),
        ])
    },
}
